import React from 'react';
export function Footer() {
  return <footer className="w-full bg-[#0A2A30] px-5 py-12 pb-28 sm:px-6 sm:pb-12" data-id="element-147" data-mp="19j53j40hsmi0">
      <div className="mx-auto max-w-2xl text-center" data-id="element-148" data-mp="206rgjav2rgpl">
        <p className="text-[11.5px] font-extrabold uppercase tracking-[0.16em] text-white/80" data-id="element-149" data-mp="2f4tjpjy7206b">
          Dott.ssa Karito · Percorso Clinico GLP-1™
        </p>
        <p className="mx-auto mt-4 max-w-lg text-[12.5px] leading-relaxed text-white/50" data-id="element-150" data-mp="2a69xrjjloody">
          Materiale educativo rivolto ai professionisti sanitari. Non sostituisce
          il giudizio clinico individuale né le raccomandazioni delle autorità
          regolatorie competenti.
        </p>
        <p className="mt-5 text-[12px] text-white/40" data-id="element-151" data-mp="1w7im03s7nesz">
          © 2026 Dott.ssa Karito. Tutti i diritti riservati.
        </p>
      </div>
    </footer>;
}